import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpBackend, HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class VersionService {

  private _endpoint = '/version';
  private anonymousHttpClient: HttpClient;

  constructor(private handler: HttpBackend) {
    this.anonymousHttpClient = new HttpClient(handler);
  }

  getVersion() {
    return this.anonymousHttpClient.get(environment.apiUrl + this._endpoint);
  }
}
